import { Spinner } from '@design-systems/canvas-ui'

export const BackgroundOverlay = (props) => {
  return (
    <div
      id="background-overlay"
      data-testid="background-overlay"
      className="align-centre-centre"
      style={{
        position: 'fixed',
        display: 'block',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': 'rgba(0,0,0,0.5)',
        'z-index': 'var(--canvas-z-index--formElement)',
        cursor: 'pointer',
      }}
    >
      {props.showSpinner && (
        <Spinner
          data-testid="background-overlay-spinner"
          size="lg"
          style={{ opacity: 1 }}
        />
      )}
    </div>
  )
}
